import { ICompanyProfile } from '../../interfaces/companyProfile/iCompanyProfile'
import { IGeneralInfoOfCompany } from '../../interfaces/companyProfile/iGeneralInfoOfCompany'
import { IMemberBoard } from "../../interfaces/companyProfile/iMemberBoard";
import { IMembers } from "../../interfaces/companyProfile/iMembers";
import { INonprofit } from "../../interfaces/iNonprofit";
import { ISocialNetwork } from "../../interfaces/iSocialNetwork";
import { ICause } from '../../interfaces/iCause';
import { ILocation } from '../../interfaces/iLocation';
import { IActivities } from "../../interfaces/companyProfile/iActivities";

export class CompanyProfile implements ICompanyProfile {
    generalInfo: IGeneralInfoOfCompany;
    activitiesList: IActivities;
    associateBoardMembers: IMemberBoard[];
    governingBoardMembers: IMemberBoard[];
    members: IMembers;
    socialMedia: ISocialNetwork[];
    causes: ICause[];
    locations: ILocation[];
    isAdmin: boolean;
    isActive: boolean;
    orgKey: string;

    constructor(companyProfile: ICompanyProfile = {} as ICompanyProfile) {
        this.generalInfo = companyProfile.generalInfo;
        this.activitiesList = companyProfile.activitiesList;
        this.associateBoardMembers = companyProfile.associateBoardMembers;
        this.governingBoardMembers = companyProfile.governingBoardMembers;
        this.members = companyProfile.members;
        this.socialMedia = companyProfile.socialMedia;
        this.causes = companyProfile.causes;
        this.locations = companyProfile.locations;
        this.isAdmin = !!companyProfile.isAdmin;
        this.isActive = !!companyProfile.isActive;
        this.orgKey = companyProfile.orgKey;
    }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/companyProfile/companyProfile.ts